<template>
    <div id="app-layout" :class="{ 'detail success': true, 'is-edit': $route.meta.isAddView }">
        <div class="main-container">
            <div :class="{ 'main-nav': true }">
                <div :class="{ container: true, detail: true }">
                    <main-navigation-header></main-navigation-header>
                    <trial-over
                        @close-modal="hide_trial_modal"
                        v-if="trial_modal_shown"
                        :shown="trial_modal_shown"
                    ></trial-over>
                    <div class="main-nav-title">
                        <a @click="do_action" href="javascript:{}" class="main-nav-back">
                            <span class="icon-arrow-left"></span>
                        </a>
                        <div class="main-nav-left">
                            {{ event_task.name }}
                            <p>
                                {{ event.name }},
                                {{ moment(event.event_time).format("dd")[0] }}
                                {{ moment(event.event_time).format("DD.MM") }}
                            </p>
                        </div>

                        <div class="main-nav-title-right">
                            <div :class="{ 'drop menu-more': true, show: dropShown }" v-click-outside="away">
                                <a @click="showDrop" href="javascript:{}"><span class="icon icon-dots"></span></a>
                                <div class="drop-content">
                                    <ul>
                                        <li>
                                            <a class="red" @click="remove_task_event()" href="javascript:{}"
                                                >Remove task</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a
                                v-if="event_task.status === 'in_progress' && !event_task_save_btn_disabled"
                                @click="mark_done"
                                href="javascript:{}"
                                :class="{
                                    'btn btn-primary': true
                                }"
                            >
                                Mark as done
                            </a>
                            <a
                                v-else-if="event_task.status === 'done'"
                                @click="mark_undone"
                                href="javascript:{}"
                                :class="{
                                    'btn btn-primary': true
                                }"
                            >
                                Mark as undone
                            </a>
                            <a
                                v-else
                                @click="save_task"
                                href="javascript:{}"
                                :class="{ 'btn btn-primary': true, disabled: task_event_save_btn_disabled }"
                            >
                                Save
                            </a>
                        </div>
                    </div>
                    <event-submenu v-if="!$route.meta.isAddView"></event-submenu>
                </div>
            </div>
            <router-view></router-view>
            <mobile-footer-menu></mobile-footer-menu>
        </div>
    </div>
</template>

<script>
import MobileFooterMenu from "./mobile-footer-menu.vue";
import MainNavigationHeader from "@/pages/main-navigation-header.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import vClickOutside from "v-click-outside";
import router from "@/router";
import EventSubmenu from "./event-submenu.vue";
import TrialOver from "./trial-over-modal.vue";

export default {
    name: "event-task-layout",
    components: { MobileFooterMenu, MainNavigationHeader, EventSubmenu, TrialOver },
    created() {},
    mounted() {
        this.get_current_event(this.$route.params.id);
        this.get_logged_in_user();
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fromRoute = from;
            vm.set_empty_event();
            vm.get_logged_in_user();

            next();
        });
    },
    watch: {
        event_task: {
            handler: function(new_val, oldVal) {
                if (new_val.id && oldVal.id) {
                    if (new_val.notes) {
                        this.set_event_task_save_btn_disabled(true);
                    }
                    if (new_val.date) {
                        this.set_event_task_save_btn_disabled(true);
                    }
                    if (new_val.time) {
                        this.set_event_task_save_btn_disabled(true);
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState("StoreEvent", ["event", "event_task_save_btn_disabled"]),
        ...mapState("StoreEvent", ["event_task"]),
        ...mapState("StoreEvent", ["task_event_save_btn_disabled"]),
        ...mapState("StoreEvent", ["global_errors"]),
        ...mapState(["user"]),

        deadline_items() {
            if (this.event.tasks && this.event.tasks.length > 0) {
                return this.event.tasks.filter(item => {
                    return (
                        item.status === "in_progress" &&
                        item.deadline &&
                        moment(item.deadline).format("DD.MM") === moment(new Date()).format("DD.MM")
                    );
                });
            } else {
                return [];
            }
        },
        done_items() {
            if (this.event.tasks && this.event.tasks.length > 0) {
                return this.event.tasks.filter(item => {
                    return item.status === "done";
                });
            } else {
                return [];
            }
        }
    },
    data() {
        return {
            trial_modal_shown: false,
            dropShown: false,
            fromRoute: null
        };
    },
    methods: {
        ...mapActions("StoreEvent", ["get_event"]),
        ...mapActions("StoreEvent", ["delete_event_task"]),
        ...mapActions("StoreEvent", ["save_event_task"]),
        ...mapMutations("StoreEvent", ["clear_event", "set_event_task_save_btn_disabled"]),
        ...mapActions(["get_logged_in_user"]),

        away() {
            if (this.dropShown) {
                this.dropShown = false;
            }
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },

        get_current_event(event_id) {
            this.get_event(event_id);
        },
        set_empty_event() {
            this.clear_event();
        },
        //save_task() {
        //this.save_event_task(this.event_task);
        //this.set_event_task_save_btn_disabled(false);
        //},

        showDrop() {
            this.dropShown = !this.dropShown;
        },
        do_action() {
            this.$router.go(-1);
            //router.push({ path: "/events/" + this.event.id });
        },
        mark_done() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                let scoped_event_task = {
                    ...this.event_task,
                    status: "done"
                };
                this.save_event_task(scoped_event_task);
            } else {
                this.trial_modal_shown = true;
            }
        },
        mark_undone() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                let scoped_event_task = {
                    ...this.event_task,
                    status: "in_progress"
                };
                this.save_event_task(scoped_event_task);
            } else {
                this.trial_modal_shown = true;
            }
        },
        save_task() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                let scoped_event_task = {
                    ...this.event_task
                };
                this.save_event_task(scoped_event_task);
            } else {
                this.trial_modal_shown = true;
            }
        },
        remove_task_event() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this.dropShown = false;
                if (confirm("Are you sure?")) {
                    let data = {
                        event_id: this.event_task.id,
                        from_route: this.fromRoute
                    };
                    this.delete_event_task(data);
                }
            } else {
                this.dropShown = false;
                this.trial_modal_shown = true;
            }
        }
    }
};
</script>

<style scoped>
.drop {
    flex: initial;
    width: initial;
    margin-left: auto;
    margin-bottom: 1.8rem;
}

.is-edit .main-nav-title p {
    margin-bottom: 4.55rem;
}

.is-edit .main-nav-title-right {
    display: flex;
    flex-direction: column;
}

.main-nav-title {
    position: relative;
}
</style>
